import { useTranslation } from 'react-i18next';
import { MyAccountType } from './types';

// The single resolver for account Type values ('Bank Account' | 'Credit Card') that double as logic
// keys: the raw value stays the match key, only the rendered label is localized. Every listing,
// table, drawer and filter goes through it — shared's own components included — so hosts never read
// Shared.* i18n keys directly (epic exit criterion) and the fallback is decided in one place.
export default function useAccountTypeLabels() {
  const { t } = useTranslation('translations');

  // Takes MyAccountType rather than string: every call site has a typed row, and a wider parameter
  // made the fallback look like it guarded real data when the only reachable miss is undefined.
  function getAccountTypeLabel(accountType: MyAccountType | undefined): string {
    // Same fallback the legacy container used: an unknown type renders the Bank Account label.
    return t([`Shared.AccountTypeItem.${accountType}`, 'Shared.AccountTypeItem.Bank Account']);
  }

  return { getAccountTypeLabel };
}
